module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.5.5 发布日志")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/actionsheet.html"
    }
  }, [_vm._v("Actionsheet")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持在 on-click-menu 参数里附带原始 menu 对象 #1772")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/alert.html"
    }
  }, [_vm._v("Alert")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持 hideOnBlur #1742")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/cell-box.html"
    }
  }, [_vm._v("CellBox")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[change] 移除默认 slot 的父级 div #1769")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/confirm.html"
    }
  }, [_vm._v("Confirm")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持方法 setInputValue 设置输入值 #1746")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/countup.html"
    }
  }, [_vm._v("Countup")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 添加属性 tag 用以定义渲染标签 #1739")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/datetime.html"
    }
  }, [_vm._v("Datetime")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持动态设置小时列表 #1749")]), _vm._v(" "), _c('li', [_vm._v("[enhance] 更加流畅的遮罩层动画")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/inline-calendar.html"
    }
  }, [_vm._v("InlineCalendar")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持多选 #1446 #1467")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/popup.html"
    }
  }, [_vm._v("Popup")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 在 deactived 事件触发时自动关闭，避免在路由切换时依然显示弹窗，可以使用 prop:hide-on-deactivated 进行禁用 #1774")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/swipeout.html"
    }
  }, [_vm._v("Swipeout")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] swipeout-item 新增 render 方法 #1688")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/tabbar.html"
    }
  }, [_vm._v("Tabbar")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持 link 上使用 replace: true 写法 #1761")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-input.html"
    }
  }, [_vm._v("XInput")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 为 on-focus on-blur 事件添加 $event 参数 #1770")]), _vm._v(" "), _c('li', [_vm._v("[fix] 修复值为空的错误判断逻辑 #1759")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-49e5518c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-49e5518c"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.5.5-247.vue
// module id = 2213
// module chunks = 274